import gql from 'graphql-tag';

const key = `UpdatePprPlan`;
const mutation = gql`
mutation ${key}($id:ID!, $plan: String!) {
updatePeriodPlanResult(input:{
    id:$id,
    plan:$plan
  }){
    id
    plan
    member {
      id
      firstName
      lastName
    }
  }
}
`;

export const UPDATE_PPR_PLAN = { key, mutation };
